const Header = ((($) => {

  function init() {
    $('.mobile-nav-btn').on('click', function() {
      $(this);
      $('.hamburger').toggleClass('is-active');
      $('body, html').toggleClass('no-scroll');
      $('.Header_nav').toggleClass('show');
      return false;
    });
    $('.Nav').on('click', 'a', function() {
      $(this);
      $('.hamburger').removeClass('is-active');
      $('body, html').removeClass('no-scroll');
      $('.Header_nav').removeClass('show');
      return false;
    });
  }

  return {
    init,
  };

}))(jQuery);

export default Header;



// WEBPACK FOOTER //
// ./src/static/js/modules/header.js